import ApplicationPreviewBoarding from './ApplicationPreviewBoarding.component';

export default ApplicationPreviewBoarding;